const SecondHeroSection = ({ title, subtitle, breadcrumbs, bgImage }) => {
  return (
    <section
    className="relative w-full min-h-[200px] md:min-h-[350px] bg-center bg-cover flex items-center justify-center"

       style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Content on top of image */}
      <div className="relative z-10 text-center text-white px-6 max-w-3xl">
        <h1 className="text-3xl md:text-5xl font-bold mb-4">
          {title}
        </h1>

        {subtitle && (
          <p className="text-lg md:text-xl mb-6 text-gray-200">
            {subtitle}
          </p>
        )}

        {breadcrumbs && breadcrumbs.length > 0 && (
          <div className="text-sm flex justify-center flex-wrap gap-2">
            {breadcrumbs.map((item, index) => (
              <span key={index} className="flex items-center">
                {item.href ? (
                  <a
                    href={item.href}
                    className="hover:text-gray-300 transition-colors"
                  >
                    {item.label}
                  </a>
                ) : (
                  <span>{item.label}</span>
                )}

                {index < breadcrumbs.length - 1 && (
                  <span className="mx-2 text-gray-400">/</span>
                )}
              </span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default SecondHeroSection;
